{
  "plans": {
    "title": "Nos offres",
    "subtitle": "Comparez ce que chaque offre ouvre. Vous pouvez changer à tout moment.",
    "current": "Votre offre actuelle",
    "free": "Gratuit",
    "included": "Inclus",
    "excluded": "Non inclus",
    "unlimited": "Illimité",
    "interval": {
      "month": "/ mois",
      "year": "/ an",
      "one_time": "une fois"
    },
    "unit": {
      "mb": "Mo",
      "count": ""
    }
  },
  "subscription": {
    "title": "Mon abonnement",
    "noSubscription": "Vous utilisez l'offre gratuite.",
    "status": {
      "trialing": "Période d'essai en cours",
      "active": "Abonnement actif",
      "past_due": "Paiement en attente — votre accès reste ouvert",
      "canceled": "Abonnement résilié",
      "incomplete": "Souscription inachevée",
      "expired": "Abonnement expiré"
    },
    "trialEnds": "Votre essai se termine le {{date}}.",
    "renewsOn": "Prochain renouvellement le {{date}}.",
    "endsOn": "Votre accès prend fin le {{date}}.",
    "seePlans": "Voir les offres",
    "cancel": "Résilier",
    "usage": "Consommation",
    "usedOf": "{{usedValue}} sur {{limitValue}}",
    "usedUnlimited": "{{usedValue}} utilisés"
  },
  "paywall": {
    "title": "Cette fonctionnalité n'est pas dans votre offre",
    "body": "« {{featureLabel}} » demande une offre supérieure.",
    "genericBody": "Cette action demande une offre supérieure.",
    "thisFeature": "cette fonctionnalité",
    "limitReached": "Vous en avez {{currentValue}} sur {{limitValue}} autorisés.",
    "quotaExceeded": "Vous avez utilisé {{usedValue}} sur {{limitValue}} autorisés.",
    "seePlans": "Voir les offres"
  },
  "features": {
    "storage.upload": "Dépôt de fichiers",
    "storage.quota_mb": "Espace de stockage",
    "storage.max_file_mb": "Taille maximale d'un fichier",
    "courses.max": "Cours publiables",
    "students.max": "Élèves inscrits",
    "messaging.enabled": "Messagerie",
    "certificates.enabled": "Certificats de réussite",
    "analytics.advanced": "Statistiques avancées",
    "branding.custom": "Personnalisation de la marque"
  },
  "admin": {
    "title": "Offre et droits",
    "currentPlan": "Offre actuelle : {{plan}}",
    "choosePlan": "Offre à activer",
    "activate": "Activer l'offre",
    "changePlan": "Changer d'offre",
    "cancel": "Résilier immédiatement"
  }
}
